import { useFees, fmtUF } from "@/lib/useFees";

const S = ({ id, title, children }) => (
  <section className="space-y-2.5" data-testid={`policy-section-${id}`}>
    <h4 className="font-semibold text-foreground flex items-center gap-2">
      <span className="grid place-items-center w-6 h-6 rounded-md bg-primary/10 text-primary text-xs font-bold">{id}</span>{title}
    </h4>
    <div className="space-y-2.5 pl-8">{children}</div>
  </section>
);
const Item = ({ t, children }) => <p><strong className="text-foreground">{t}:</strong> {children}</p>;
const Sub = ({ t, children }) => (
  <div className="rounded-lg border border-border/70 p-3 space-y-1.5">
    <p className="font-medium text-foreground">{t}</p>
    <ul className="list-disc pl-5 space-y-1">{children}</ul>
  </div>
);
const B = ({ children }) => <strong className="text-foreground">{children}</strong>;

export const PolicyText = () => {
  const f = useFees();
  const pub = `${fmtUF(f?.publication_fee_uf ?? 0.07)} UF`;
  return (
  <div className="space-y-6 text-sm text-muted-foreground leading-relaxed" data-testid="policy-text">
    <S id="A" title="Tarifas y Fichas">
      <Item t="Registro gratuito">Crear tu cuenta de Maestro en VIVOTaller es y seguirá siendo <B>100% gratuito</B>. No existen costos de suscripción ni cobros mensuales recurrentes.</Item>
      <Item t="Fichas">VIVOTaller solo cobra por la compra de <B>Fichas</B>, la moneda virtual de la plataforma. <B>1 Ficha = {pub} + IVA = 1 publicación de taller.</B> A todos los precios se les suma el IVA (19%) y se cobra el total con IVA incluido.</Item>
      <Sub t="Paquetes disponibles:">
        <li><B>Básico:</B> 1 ficha por el valor de 1.</li>
        <li><B>Pack Creador:</B> 4 fichas por el valor de 3 (25% de ahorro).</li>
        <li><B>Pack Pro:</B> 7 fichas por el valor de 5 (28% de ahorro).</li>
      </Sub>
      <Item t="Usos">Con 1 ficha publicas un taller o lo destacas durante 3 días en Explorar.</Item>
      <Item t="Fichas de regalo">Recibes 1 ficha al completar tu perfil y 1 ficha cada 10 alumnos distintos que asistan (con registro de asistencia por QR) entre todos tus talleres.</Item>
      <Item t="Vigencia">Las fichas compradas o regaladas vencen <B>1 año</B> después de recibirlas. Las fichas no son reembolsables ni canjeables por dinero.</Item>
    </S>
    <S id="B" title="Pago de los Alumnos">
      <p>Reservar un cupo en VIVOTaller es <B>gratis para el alumno</B> y queda confirmado al instante. El alumno paga el valor del taller <B>directamente al Maestro</B>; VIVOTaller no recauda ni administra esos pagos y no cobra comisión por reserva.</p>
      <p>El Maestro puede marcar en su panel cada inscripción como <B>pagada</B> o <B>sin pagar</B> para llevar su propio control.</p>
    </S>
    <S id="C" title="Cancelación por parte del Alumno">
      <Sub t="Dentro del plazo establecido por el maestro:">
        <li>El cupo se libera de forma automática para permitir la inscripción de otro interesado.</li>
        <li>Si el alumno ya había pagado, la devolución se acuerda y gestiona directamente con el Maestro.</li>
      </Sub>
      <Sub t="Fuera del plazo establecido:">
        <li>La cancelación queda sujeta a las condiciones que el Maestro haya informado al alumno.</li>
      </Sub>
    </S>
    <S id="D" title="Cancelación del Taller por parte del Maestro">
      <Item t="Ficha de publicación">Si decides suspender o cancelar un taller que ya se encontraba publicado, la ficha usada para publicarlo <B>no se devuelve</B>.</Item>
      <Item t="Alumnos inscritos">Si la cancelación ocurre con alumnos que ya pagaron, el maestro del taller es responsable de devolver el <B>100% del monto pagado</B> por cada alumno afectado.</Item>
    </S>
    <S id="E" title="Inhabilitar un Maestro">
      <p>Para proteger la confianza y seguridad de la comunidad, los alumnos inscritos en un taller pueden <B>denunciar a su Maestro</B> desde la ficha del taller o el perfil del Maestro, eligiendo el motivo (incumplimiento grave o fraude, infraestructura o materiales inadecuados, calidad pedagógica, seguridad, trato o discriminación, y cobros indebidos).</p>
      <Item t="Efecto inmediato">Al recibir una denuncia, la cuenta del Maestro queda <B>deshabilitada de inmediato</B>: sus talleres dejan de mostrarse, nadie puede reservarlos y las sesiones ya reservadas quedan suspendidas.</Item>
      <Item t="Revisión">El Maestro es notificado por correo, sin revelar la identidad del denunciante. La cuenta permanece deshabilitada hasta que el equipo de VIVOTaller contacte al Maestro y revise el caso, pudiendo rehabilitarla o mantenerla bloqueada.</Item>
    </S>
  </div>
  );
};
